import { keyBy } from "lodash";

const initialState = {
  campaign: {},
};

export default function entities(state = initialState, action) {
  if (action.entity) {
    if (!action.remove) {
      // Upsert entity

      if (Array.isArray(action.data)) {
        state = Object.assign({}, state, {
          [action.entity]: Object.assign(
            {},
            state[action.entity],
            keyBy(action.data, "id")
          ),
        });
      } else {
        state = Object.assign({}, state, {
          [action.entity]: Object.assign({}, state[action.entity], {
            [action.data.id]: action.data,
          }),
        });
      }
    } else {
      // Remove entity
      var newState = Object.assign({}, state);
      delete newState[action.entity][action.data.id];
      state = newState;
    }
  }
  return state;
}
